<div class="bn-mobile-menu d-block d-lg-none">
  <ul class="bn-mobile-menu__items row g-0">
    @for (menuItem of menuItems; track menuItem.route ?? $index) {
      <li class="bn-mobile-menu__item col">
        <ng-container *ngTemplateOutlet="itemAction; context: { menuItem: menuItem }" />
      </li>
    }
  </ul>
</div>

<ng-template
  #itemAction
  let-isChildItem="isChildItem"
  let-menuItem="menuItem">
  @if (menuItem.action) {
    <a
      class="bn-mobile-menu__link"
      data-e2e="LayoutMobileMenuActionLink"
      (click)="onMenuItemClick(menuItem.action)">
      <ng-container *ngTemplateOutlet="buttonContent" />
    </a>
  } @else {
    @if (menuItem.route) {
      <a
        ariaCurrentWhenActive="page"
        class="bn-mobile-menu__link"
        routerLinkActive="bn-mobile-menu__link--active"
        [routerLink]="menuItem.route || null"
        [routerLinkActiveOptions]="{ exact: menuItem.route === '/' }">
        <ng-container *ngTemplateOutlet="buttonContent" />
      </a>
    } @else {
      @if (menuItem.url) {
        <a
          class="bn-mobile-menu__link"
          [href]="menuItem.url"
          [target]="menuItem.target">
          <ng-container *ngTemplateOutlet="buttonContent" />
        </a>
      }
    }
  }

  <ng-template #buttonContent>
    @if (menuItem.icon) {
      <fa-icon
        class="bn-mobile-menu__icon"
        [icon]="menuItem.icon" />
    }
    @if (!menuItem.icon && menuItem.name) {
      <span>{{ menuItem.name }}</span>
    }
  </ng-template>
</ng-template>
